import { KeyValue } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IColumnTableBasic, IDataTableBasicComponent } from '@pacifico/interfaces/components.interface';
import { Util } from '@pacifico/utils/util';
import { Subject, Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Component({
	selector: 'app-table-basic',
	templateUrl: './table-basic.component.html',
	styleUrls: ['./table-basic.component.scss']
})
export class TableBasicComponent implements OnInit, OnDestroy {
	@Input() dataTable!: IDataTableBasicComponent;
	@Input() event?: Observable<number>;
	@Input() emptyData = 'La cuenta no tiene detalles.';

	reloadbuttonPage: Subject<number> = new Subject<number>();

	@Input() startItem = 0;
	@Input() endItem = 0;
	@Input() itemsPerPage = 15;

	private _eventSubscription?: Subscription;
	ngOnInit(): void {
		this.onPageChange(1);
		this._eventSubscription = this.event?.subscribe((page) => {
			this.onPageChange(page);
			this.reloadbuttonPage.next(1);
		});
	}

	ngOnDestroy(): void {
		this._eventSubscription?.unsubscribe();
	}

	getAlign(index: number): string | null {
		const configColumn = this.dataTable.configColumn.find((item) => item.indexColumn === index);
		if (configColumn) {
			return configColumn.textAlign as string;
		}
		return null;
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	originalOrder = (_a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
		return 0;
	};

	getConfig(index: number): IColumnTableBasic | null {
		const configColumn = this.dataTable.configColumn.find((item) => item.indexColumn === index);
		if (configColumn) {
			return configColumn;
		}

		return null;
	}

	isNegative(value: string): boolean {
		return Util.isNegative(value);
	}

	onPageChange(page = 1): void {
		this.startItem = (page - 1) * this.itemsPerPage;
		this.endItem = page * this.itemsPerPage;
		window.scroll(0, 0);
	}
}
